/**
 * @description Makes sure that value provided isn't falsey and that the value isn't the string "null" or "undefined".
 * This is good for validating cookies or url values that are always strings.
 * @param {*} val
 * @returns {Boolean}
 */
export const notUndefined = (val) => {
    return val && !['undefined', 'null'].includes(val) ? true : false
}
